/* -------------------------------------------------------------------------- */
/*                               Units Project                                */
/* -------------------------------------------------------------------------- */

export const UNITS_PROJECT = [
	{ value: 'KWH', label: 'kWh' },
	{ value: 'KG', label: 'kg' },
];
